import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Modal, ModalBody, ModalFooter, ModalHeader, InputGroup, Input } from 'reactstrap';
import Button from '../../../../../common/buttons/DeprecatedButton/DeprecatedButton';
import { ENTER_KEY_NAME } from '@mm/constants/keys-codes';
import '../PageOverviewPane/PageOverviewPane.scss';
import '../../../../../common/scss/input.scss';
import updateListener from '../../../../../common/helpers/utils/EventListenerUtils';
import '../../../../../../src/editor/features/build/components/modals/Modal.scss';

export default class PageInfoEditor extends Component {
  static propTypes = {
    closeModal: PropTypes.func.isRequired,
    onCreatePage: PropTypes.func.isRequired,
    showModal: PropTypes.bool.isRequired,
    pageGroupId: PropTypes.number.isRequired,
  };

  constructor(props) {
    super();

    this.state = {
      page: { name: '', pageGroupId: props.pageGroupId },
    };
  }

  onKeyDown = e => {
    if (e.key === ENTER_KEY_NAME) {
      e.stopPropagation();
    }
  };

  onPageInfoEditorKeyDown = e => {
    if (e.key === ENTER_KEY_NAME && !e.cancelBubble) {
      if (!this.isNameBlank()) {
        this.onCreatePage();
        e.preventDefault();
      }
    }
  };

  UNSAFE_componentWillReceiveProps(nextProps) {
    const {
      props: { showModal },
      onPageInfoEditorKeyDown,
    } = this;
    updateListener(
      nextProps.showModal,
      showModal,
      'keydown',
      onPageInfoEditorKeyDown,
    );
    this.setState({
      page: { name: '', pageGroupId: nextProps.pageGroupId },
    });
  }

  onChangeGroup = (e, field) => {
    this.setState({
      page: {
        ...this.state.page,
        [field]: e.target.value,
      },
    });
  };

  setRef = node => {
    this.pageGroupNameInput = node;
  };

  setFocus = () => {
    if (this.pageGroupNameInput) {
      this.pageGroupNameInput.focus();
    }
  };

  isNameBlank = () => this.state.page.name.trim() === '';

  onCreatePage = () => {
    this.props.onCreatePage(this.state.page);
    this.props.closeModal();
  };

  render() {
    const { page } = this.state;
    const { setRef, setFocus } = this;
    return (
      <Modal
        onOpened={setFocus}
        isOpen={this.props.showModal}
        toggle={this.props.closeModal}
        className="modal-component"
      >
        <ModalHeader toggle={this.props.closeModal}>
          <h3>Create Dialogue</h3>
        </ModalHeader>
        <ModalBody>
          <InputGroup className="mb-3 chatbot__input-group">
            <Input
              innerRef={setRef}
              type="text"
              maxLength="50"
              value={page.name}
              onChange={e => {
                this.onChangeGroup(e, 'name');
              }}
              placeholder="Enter Dialogue name"
            />
          </InputGroup>
        </ModalBody>
        <ModalFooter>
          <Button outline red onClick={this.props.closeModal} invert small>
            Cancel
          </Button>
          <Button
            onClick={this.onCreatePage}
            disabled={this.isNameBlank()}
            small
          >
            <i className="fa fa-plus-circle fa-lg warning" /> Create Dialogue
          </Button>
        </ModalFooter>
      </Modal>
    );
  }
}
